export default __webpack_public_path__ + "static/works_3-103e7aa5efbeaa28756f21e3b884c64f.png";